<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="toc"><a class="xref" href="#/chiprager0007#intro">Introduction: Earthly Dangers and Science</a></p>
<p class="toc"><a class="xref" href="#/chiprager0008#ch01"><b>1</b>   Climate Change</a></p>
<p class="toc"><a class="xref" href="#/chiprager0009#ch02"><b>2</b>   Volcanoes</a></p>
<p class="toc"><a class="xref" href="#/chiprager0010#ch03"><b>3</b>   Earthquakes and Tsunamis</a></p>
<p class="toc"><a class="xref" href="#/chiprager0011#ch04"><b>4</b>   Hurricanes</a></p>
<p class="toc"><a class="xref" href="#/chiprager0012#ch05"><b>5</b>   Rogue Waves, Landslides, Rip Currents, Sinkholes, and Sharks</a></p>
<p class="toc"><a class="xref" href="#/chiprager0013#conc">Conclusion: Knowing Enough to Act</a></p>
<p class="tocbmf"><a class="xref" href="#/chiprager0014#plates">Color Gallery</a></p>
<p class="tocbm"><a class="xref" href="#/chiprager0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiprager0016#read">Further Reading</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-prager-0006.vue?55aa3f56